import React from "react";
import { useNavigate } from "react-router-dom";

const Modal = () => {
  const navigate = useNavigate();

  const goToSignup = () => {
    navigate("/signup");
  };

  return (
    <div
      className="modal fade"
      id="loginRequired"
      tabindex="-1"
      aria-labelledby="loginRequiredLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="loginRequiredLabel">
              Signup required
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            You need to be signup to publish your XML
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              onClick={goToSignup}
            >
              Sign up
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
